import {default as _} from 'lodash';
import { Component,ViewChild,EventEmitter,Input,OnInit,Output } from "@angular/core";
import { DatePipe,JsonPipe,LowerCasePipe,UpperCasePipe,NgClass,CommonModule } from '@angular/common';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { HttpErrorResponse } from '@angular/common/http';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { UserService } from "app/Shared/Services/user.service";
import { DataService } from 'app/Shared/Services/data.service';
import { CommentViewerService } from "./comment-viewer.service";
import { ConfirmationService,MessageService } from 'primeng/api';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Table, TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DatepickerCalendarComponent } from '../datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from '../datepicker-calendar/datepicker.service';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CompReviewServiceService } from 'app/Pages/cat-dashboard/comparative-review/comp-review-service.service';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-comment-viewer',
    imports: [DatePipe, LowerCasePipe, NgClass, CommonModule,ButtonModule,
        TableModule, FormsModule, MatTooltipModule, ConfirmDialogModule, DialogModule, MatProgressSpinnerModule, ToastModule,
        MatAutocompleteModule, MatChipsModule, MatFormFieldModule, MatIconModule, DatepickerCalendarComponent, RadioButtonModule, InputTextModule
    ],
    templateUrl: './comment-viewer.component.html',
    styleUrls: ['./comment-viewer.component.scss'],
    providers: [MessageService, CommentViewerService]
})
export class CommentViewerComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table | any;
  //@ViewChild('tableRef', { static: false }) private tableRef?: Table;
  @ViewChild('tableHeaderCheckboxRef', { static: false }) private tableHeaderCheckboxRef?: any;

  @Output() closeCommentDialog: EventEmitter<any> = new EventEmitter();
  @Input('pageName') pageName: any = [];
  @Input('selectedRow') selectedRow: any = [];
  @Input('isOpenCommentViewer') isOpenCommentViewer: boolean = false;
  @Input('isDisplayDateRangeFilter') isDisplayDateRangeFilter: boolean = false;
  @Input('isDisplayAddCommentForm') isDisplayAddCommentForm: boolean = false;
  @Input('gridColumnsJSON') gridColumnsJSON!: any[];
  @Input('commentStaticFilters') commentStaticFilters!: any[];
  @Input('commentAPIDetail') commentAPIDetail: any;

  private allEnabledRowSelected = false;
  selectedTableRows!: any[];
  cols: any = [];
  tbldatamsg = 'L o a d i n g . . . . .';
  isDataLoading: boolean = true;
  filterReportDate: any = [];
  todate: string = "";
  staticAvailableFilters: any = [];
  DefaultFilterArray: any = [];
  LastExecutionDate: any[] = [];
  commentData: any = [];
  isOpenDateRangeFilter: boolean = false;
  rowcount: number = 5;
  totalRecords : number = 1;
  startLimit: any = 0;
  endLimit: number = 0;
  pageNumber: any = 1;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  commentStatement: any;
  maxCharsLength: number = 256;
  selectedStatus:any ="Open";
  isDisabledDeleteBtn:boolean = false; 

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public userService: UserService,
    public messageService: MessageService,
    public dataService: DataService,
    public CommentViewerService: CommentViewerService,
    private confirmationService: ConfirmationService,
    public readonly compReviewServiceService:CompReviewServiceService,
    private datepickerService:DatepickerService,
    private sortPipe: SortPipe) {
  }

  ngOnInit() {
    this.isDataLoading = false;
    /* Dynamically Add Rows Per Page for CAT Recon Comment Viewer Screen only */
    this.rowsPerPageOptions = [5, 10, ...this.constantService.DEFAULT_ROWSPERPAGEOPTION];

    let todate: any;
    todate = this.userService.getyyyyMMddDateFormate(new Date());
    if(this.pageName == this.compReviewServiceService.pageName){
      todate = this.compReviewServiceService.LastExecutionCompDate[0];
    }
    this.LastExecutionDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionDate[0] = (todate);// Fromdate
      this.LastExecutionDate[1] = (todate);// Todate
      this.filterReportDate = [todate, todate]; // Set Report Date for Date Filters 
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      if(this.selectedRow.length == 1){
        this.selectedStatus = this.selectedRow[0]['status']== 'OPEN' ? 'Open': this.selectedRow[0]['status'];
        if(this.pageName == this.compReviewServiceService.pageName){
         this.selectedStatus = this.selectedRow[0]['commentStatus']!=undefined ? this.selectedRow[0]['commentStatus']:'Open';
        }
      }
      else{
        this.selectedStatus = null;
  
      }

      this.isDisabledDeleteBtn = this.compReviewServiceService.pageName+",Comparative Review".includes(this.pageName);
      this.defaultFilter();
      this.getColumns();
      this.getData();
    }
  }

  getColumns() {
    let column: any = this.gridColumnsJSON;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  
  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  onSelectionChange(selection: any[]) {
    for (let i = selection.length - 1; i >= 0; i--) {
      let data = selection[i];
      if(!data.isActive) {
        selection.splice(i, 1);
      }
    }
    this.selectedTableRows = selection;
  }

  // Table Header Checkbox to deal with Disabled and Enabled Row Checkboxes
  onHeaderCheckboxToggle(event: any): void {
    if (event?.originalEvent?.skipNextToggleCallback) return;

    this.allEnabledRowSelected = !this.allEnabledRowSelected;
    this.tableHeaderCheckboxRef.checked = this.allEnabledRowSelected;

    if (!this.allEnabledRowSelected) {
      this.dt.toggleRowsWithCheckbox({ skipNextToggleCallback: true } as any, false);
    }
  }

  getResolutionWidth() {
    return window.innerWidth - 400 + 'px';
  }

  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  sort(event: any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.commentData = this.sortPipe.transform(this.commentData, this.sortData.order, this.sortData.field);
    } else {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
    }
  }

  getData() {
    this.selectedTableRows = [];
    this.commentData = [];
    this.isDataLoading = true;
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    let filterParams;
    if(this.commentAPIDetail.Module.indexOf('Comparative')>=0){
      filterParams = this.prepareSearchParametersForCompReview();
    } else {
      filterParams = this.prepareSearchParameters();
    }

    
    if(this.commentAPIDetail.Module.indexOf("Exception")>=0){
      Object.assign(filterParams, { startLimit: this.Limit.Start.toString(), endLimit: this.Limit.End.toString(), selectedRow: this.selectedRow, reportDate:this.LastExecutionDate[0]});
    }else {
      Object.assign(filterParams, { startLimit: this.Limit.Start.toString(), endLimit: this.Limit.End.toString(), selectedRow: this.selectedRow });
    }
  
    /* set post dataset */
    this.CommentViewerService.getComments(this.commentAPIDetail.GetCommentURL, filterParams)
    .subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        // Set Status Field (Active / InActive) for Export CSV
        if(dataset["Data"] && dataset.Data.length > 0) {
          dataset.Data = dataset.Data.map((dataObj: any) => {
            if(dataObj.hasOwnProperty('isActive')) {
              dataObj.isActive = (dataObj.isActive ? 'Active' : 'InActive');
            }
            return dataObj;
          });
          this.commentData = dataset.Data;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(dataset.totalCount);
          this.CommentViewerService.browseCommentViewerTotalCount=this.totalRecords;
        }else{
          this.commentData = [];
          this.totalRecords = 1;
          this.CommentViewerService.browseCommentViewerTotalCount=0;
        }
        if (dataset["Data"] && dataset.Data.length === 0) {
        this.tbldatamsg = "No data found";
        }
        this.isDataLoading = false;
      }, error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }


  prepareSearchParametersForCompReview(): any {
    let filterParams:any = {
      CATReporterIMID: this.userService.getActiveMPID(),
      fromDate:this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]),
      toDate:this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]),
      startLimit: this.startLimit,
      endLimit:this.endLimit,
      application: this.commentAPIDetail.Module
    };


    if(this.selectedRow.length==0 && this.filterReportDate.length>1){
      filterParams["fromDate"]=this.userService.getFirstDateOfMonth(new Date(this.filterReportDate[0]));
      filterParams["toDate"]=this.userService.getLastDateOfMonth(new Date(this.filterReportDate[1]));
    }

    if(this.selectedRow.length>0){
      filterParams["rowID"]=this.selectedRow[0]["rowID"];
    }


    if(this.selectedRow.length>0 && filterParams["rowID"]==undefined){
      filterParams["rowID"]=this.selectedRow[0]["id"];
    }

    if(this.selectedRow.length>0 && this.selectedRow[0]["sampleName"]){
      filterParams["sampleName"]=this.selectedRow[0]["sampleName"];
    }

    return filterParams;
  }

  prepareSearchParameters() {
    this.LastExecutionDate = [];
    
    if(this.isDisplayDateRangeFilter && this.filterReportDate.length > 0) {
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]));
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]));
    } else if(this.isDisplayDateRangeFilter && this.filterReportDate.length===0) {
      this.LastExecutionDate.push(this.selectedRow.reportDate);
      this.LastExecutionDate.push(this.selectedRow.reportDate);
    }
     if(this.pageName == this.compReviewServiceService.pageName){
      this.LastExecutionDate[0]=(this.userService.getFirstDateOfMonth(this.filterReportDate[0]));
      this.LastExecutionDate[1]=(this.userService.getLastDateOfMonth(this.filterReportDate[1]));
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.LastExecutionDate[0];
    filterData[0].values[1] = this.LastExecutionDate[1];

    let filterParams:any = {
      CATReporterIMID: this.userService.getActiveMPID(),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      data: filterData
    };
    if(this.selectedRow.length>0 && this.selectedRow[0]["sampleName"]){
      filterParams["sampleName"]=this.selectedRow[0]["sampleName"];
      filterParams["reportDate"]=this.selectedRow[0]["reportDate"];
    }

    return filterParams;
  }

  insertComment() {
    this.isDataLoading = true;
    
    let filterData: any;

    if(this.commentAPIDetail.Module.indexOf('Comparative')>=0){

      filterData = {
        CATReporterIMID: this.userService.getActiveMPID(),
        user: this.userService.getUserName(),
        userName: this.userService.getUserFirstName(),
        commentStatement: this.commentStatement,
        commentStatus:this.selectedStatus == 'Open'? 'OPEN' : this.selectedStatus,
        application:this.commentAPIDetail.Module
      };

      if(this.selectedRow.length>0 && this.selectedRow[0]){
        filterData["rowID"]=this.selectedRow[0]["rowID"]!=undefined ? this.selectedRow[0]["rowID"] : this.selectedRow[0]["id"];
        filterData["firmROEID"]=this.selectedRow[0]["firmROEID"];
        filterData["orderID"]=this.selectedRow[0]["orderID"];
        filterData["symbol"]=this.selectedRow[0]["symbol"]!=undefined ? this.selectedRow[0]["symbol"]: this.selectedRow[0]["optionID"];
        filterData["failureDescription"]=this.selectedRow[0]["failureDescription"]!=undefined ? this.selectedRow[0]["failureDescription"]: null;
        filterData["sampleName"]=this.selectedRow[0]["sampleName"]!=undefined ? this.selectedRow[0]["sampleName"]: null;
        filterData["reportDate"]=this.selectedRow[0]["reportDate"]!=undefined ? this.selectedRow[0]["reportDate"]: null;
      }

      if(filterData["reportDate"]==undefined){
        filterData["reportDate"]=this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]);
      }


  
      if(this.selectedRow[0]["sampleName"]){
        filterData["sampleName"]=this.selectedRow[0]["sampleName"];
      }
      
    } else {
      filterData = {
        CATReporterIMID: this.userService.getActiveMPID(),
        user: this.userService.getUserName(),
        userName: this.userService.getUserFirstName(),
        selectedRow: this.selectedRow,
        commentStatement: this.commentStatement,
        updatedStatus:this.selectedStatus == 'Open'? 'OPEN' : this.selectedStatus
      };
    }
    
  
    this.CommentViewerService.addComment(this.commentAPIDetail.AddCommentURL, filterData)
    .subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
        this.getData();
        this.CommentViewerService.getBrowseCommentViewerCount(this.selectedRow[0]["reportDate"],this.commentAPIDetail.Module);
        this.commentStatement = '';
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Comment hasn\'t been Added' });
        this.isDataLoading = false;
      }
    });
  }

  showDateFilter() {
    this.isOpenDateRangeFilter = true;
  }

  applyFilter() {
    let fromdate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]);
    let todate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]);

    this.LastExecutionDate = [];
    if ((fromdate != "" || fromdate != undefined || fromdate != null) && (todate != "" || todate != undefined || todate != null)) {
      this.LastExecutionDate[0] = (fromdate);// Fromdate
      this.LastExecutionDate[1] = (todate);// Todate
    }

    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }

  removeRecords(e: any): boolean | void {
    let msg = '';
    if(this.selectedTableRows.length === 0) {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: 'Please select any record to perform action' });
      return false;
    }
    if (this.selectedTableRows.length > 1) {
      msg = 'Are you sure that you want to delete All?';
    } else {
      msg = 'Are you sure that you want to delete?';
    }
    this.confirmationService.confirm({
      message: msg,
      acceptIcon:'pi pi-check',
      rejectIcon:'pi pi-times',
      key: 'DeleteconfirmationDialoge',
      accept: () => {
        let filterData = {
          CATReporterIMID: this.userService.getActiveMPID(),
          user: this.userService.getUserName(),
          userName: this.userService.getUserFirstName(),
          selectedRow: this.selectedRow,
          selectedComments: this.selectedTableRows,
        };
        this.isDataLoading = true;
        this.CommentViewerService.deleteComment(this.commentAPIDetail.DeleteCommentURL, filterData)
        .subscribe({
          next: (Element: any) => {
            let dataset: any = Element;
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
            this.getData();
          },  
          error: (err: HttpErrorResponse) => {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Comment hasn\'t been Deleted' });
            this.isDataLoading = false;
          },          
        });
      }
    });
  }

  exportToCSV() {
    let filterParams: any;

    if(this.commentAPIDetail.Module.indexOf('Comparative')>=0){
      filterParams = this.prepareSearchParametersForCompReview();
    } else {
      filterParams = this.prepareSearchParameters();
    }
    Object.assign(filterParams, { startLimit: this.Limit.Start.toString(), endLimit: this.totalRecords.toString(), selectedRow: this.selectedRow });
    this.CommentViewerService.exportCSV(this.commentAPIDetail.GetCommentURL, this.gridColumnsJSON, filterParams, this.pageName);
  }

  closeDialogbox() {
    this.filterReportDate = [];
    this.commentStatement = "";
    this.selectedTableRows = [];

    /* Reset Pagination */
    this.totalRecords = 0;
    this.pageNumber = 1;
    this.dt.first = 1;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.closeCommentDialog.emit();
  }
  getDateEmitter(){
    this.filterReportDate[0]=this.datepickerService.dateRange[0];
    this.filterReportDate[1]=this.datepickerService.dateRange[1];
  }

}